import PromoPage from "./PromoPage";
import SearchBox from "../components/SearchBox";
import { QuerySuggestions } from "./components/QuerySuggestions";
import InstantSearchResults from "./InstantSearchResults";
import InstantSearch from "./InstantSearch";
import { useSearchBox } from "react-instantsearch";

function TheContent() {
  const { query } = useSearchBox();

  return (
    <>
      {query ? (
        <InstantSearchResults />
      ) : (
        <PromoPage />
      )}
    </>
  );
}

export default function InstantSearchContent() {
  return (
    <InstantSearch>
      {/* Topbar to push down content */}
      <div className="tw-mt-searchHeight"></div>

      <div className="tw-gap-x-10 lg:tw-grid lg:tw-grid-cols-[280px,1fr] xl:tw-grid-cols-[minmax(max-content,280px)_1fr] tw-h-searchHeight tw-overflow-y-visible">
        {/* Left */}
        <div className="tw-min-w-[200px]">
          <SearchBox />
          <QuerySuggestions />
        </div>

        {/* Right */}
        <TheContent />
      </div>
    </InstantSearch>
  );
}